import React from "react";
import { IconButton } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import { color, fontSize } from "style/constants";
import { Paragraph, StyledGrid } from "components/simple";

interface Props {
  currentPage: number;
  numOfPages: number;
  paginateDecrease(): void;
  paginateIncrease(): void;
}

const Pagination: React.FC<Props> = ({
  currentPage,
  numOfPages,
  paginateDecrease,
  paginateIncrease
}: Props) => {
  return (
    <StyledGrid container justifyContent="space-between" alignItems="center" marginTop="0px">
      <StyledGrid item>
        <IconButton
          aria-label="Previous"
          color="secondary"
          onClick={paginateDecrease}
          disabled={currentPage === 1}
        >
          <ChevronLeftIcon />
        </IconButton>
      </StyledGrid>
      <Paragraph color={color.BLACK} fontSize={fontSize.medium} fontWeight="normal">
        {`${currentPage} of ${numOfPages}`}
      </Paragraph>
      <StyledGrid item>
        <IconButton
          aria-label="Next"
          color="secondary"
          onClick={paginateIncrease}
          disabled={currentPage === numOfPages}
        >
          <ChevronRightIcon />
        </IconButton>
      </StyledGrid>
    </StyledGrid>
  );
};

export default Pagination;
